import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../app/routes.js';

export function Topbar({ onMenu }) {
  return (
    <header className="topbar">
      <button className="menu-button" type="button" onClick={onMenu} aria-label="Apri menu">☰</button>
      <div className="topbar-title">
        <strong>MyWorld Gestionale</strong>
        <span>V2</span>
      </div>
      <Link className="account-link" to={ROUTES.account}>Account</Link>
    </header>
  );
}
